// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IGCUsageInfo {
	statusTimestamp: string | undefined;

	totalAvailableMemoryBytes: number;

	heapSizeBytes: number;

	memoryLoadBytes: number;

	highMemoryLoadThresholdBytes: number;

	totalCommittedBytes: number;

	promotedBytes: number;

	pinnedObjectsCount: number;

	fragmentedBytes: number;

	gen0Collections: number;

	gen1Collections: number;

	gen2Collections: number;

	totalPauseDurationMilSec: number;

	$type?: string | undefined;
}
export class GCUsageInfo {
	constructor(data?: IGCUsageInfo) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.statusTimestamp) { this.statusTimestamp = new Date(data.statusTimestamp); }
	}

	statusTimestamp: Date | undefined = new Date();

	totalAvailableMemoryBytes: number = 0;

	heapSizeBytes: number = 0;

	memoryLoadBytes: number = 0;

	highMemoryLoadThresholdBytes: number = 0;

	totalCommittedBytes: number = 0;

	promotedBytes: number = 0;

	pinnedObjectsCount: number = 0;

	fragmentedBytes: number = 0;

	gen0Collections: number = 0;

	gen1Collections: number = 0;

	gen2Collections: number = 0;

	totalPauseDurationMilSec: number = 0;

	static $type: string = "Shared.Models.View.Hardware.GCUsageInfo, ";
	$type?: string | undefined = GCUsageInfo.$type;
}

